/** Единственный источник контактов и ссылок для юридических страниц: футер, политика, оферта, магазин. */
export const operator = {
  email: 'dubleweb@gmail.com',
  siteUrl: 'https://ratten.run',
  offerUrl: '/legal/offer.pdf',
  discordUrl: 'https://discord.gg/Rs9mHy8NVv',
  /** Код согласования с платёжным сервисом; после регистрации кассы удалить константу, ключи локалей и вывод в StoreTermsPage. */
  moderationCode: 'mellivora'
} as const;
